(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsActivityWrapper', rmsActivityWrapper);

    function rmsActivityWrapper() {
        return {
            restrict: 'E',
            scope: {
                item: '='
            },
            controller: rmsActivityWrapperCtrl,
            controllerAs: 'vm',
            bindToController: true,
            transclude: true,
            templateUrl: 'common/app/components/activities/list-panel/activity-wrapper'
        };
    }

    function rmsActivityWrapperCtrl(lodash) {
        var vm = this;
        this.$onInit = function() {
            vm.getIcon = () => {
                if (lodash.has(vm.item, 'typeIcon')) {
                    return vm.item.typeIcon;
                }
                switch (vm.item.type) {
                    case "email":
                        return 'fa-envelope';
                    case "log":
                        return 'fa-user';
                    case "schedule":
                        return 'fa-calendar';
                    case 'task':
                        return 'fa-thumb-tack';
                    case 'note':
                        return 'fa-sticky-note-o';
                }
            };
        }
    }
})();